module.exports = __webpack_public_path__ + "img/jp_xhs.1e3d5af.svg";